import { configureStore } from "@reduxjs/toolkit";
import asignToPersonSlice from "./slices/asignToPerson.slice";
import { UIListService } from "reduxStore/services/uiList.services" 


export const store = configureStore({
    reducer: {
        asignToPersonSlice,
        [UIListService.reducerPath]: UIListService.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat([
            UIListService.middleware
        ]),
});


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
